import { render } from "./CurrencyInput.vue?vue&type=template&id=19ba3fd0&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"

import "./CurrencyInput.vue?vue&type=style&index=0&id=19ba3fd0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ba3fd0"]])

export default __exports__